















import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { FontAwesomeIconProps } from '@front-app/vendor/icon-definitions';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		FontAwesomeIcon,
	},
	props: {
		icon: {
			type: Object as PropType<FontAwesomeIconProps>,
			required: true,
		},
		size: {
			type: String as PropType<Size>,
			default: Size.LARGE,
		},
	},
	setup() {
		return {
			Size,
		};
	},
});
